import { render, staticRenderFns } from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=template&id=21f5c603&scoped=true"
import script from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=style&index=0&id=21f5c603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5c603",
  null
  
)

export default component.exports